//init smoothscroll
import smoothscroll from 'smoothscroll-polyfill';
smoothscroll.polyfill();

//expose utils
import serializeForm from './general/utils/consultation/serialize-form';
import postToLead from './general/utils/lead-service';
import { validate } from './general/utils/validation';
import { slideDown, slideUp, slideToggle } from './general/startup/slide';
import { animatePriceField } from './general/plugins/animateNumber';
import { initCmsCaptchaForms, getCaptchaToken, postToLeadWithCaptcha as postToLeadWithCaptchaForForm } from './general/utils/captcha-cms-forms';
window.websiteUtils = {
  postToLead,
  serializeForm,
  validate,
  slides: {
    slideUp,
    slideDown,
    slideToggle
  },
  animatePriceField,
  getCaptchaToken,
  postToLeadWithCaptcha: postToLeadWithCaptchaForForm
};

window.dispatchEvent(new Event('websiteUtilsReady'));

initCmsCaptchaForms();

// import general files
import './general/index';
import './general/dentalCalculation';
import './general/healthX';
import './general/hero-link-back';
import './general/milestones';
import './general/qqc';
import './general/stickyNavigationTabs';
import './general/tabList';
import './general/tariffTabs';
import './general/lean-assistant';
import './general/scroll-navigation';
import './general/scroll-table';
import './general/tariffs-module/tariff_tables';
import './general/action-banner';
import './internal-consultation.ts';
import './general/comprehensive-qqc_v2.ts';
import './general/custom-consent.ts';
import './general/trust_v2.ts';
